// =====================================================================
// Instanzkonfiguration im Browser (shared/instance.ts).
//
// Der Server bettet sie als window.__HUB_INSTANCE__ in die index.html ein
// (server/lib/instance-config.ts). Fehlt sie (Vite Dev Server, Tests),
// gelten die Standardwerte, also das heutige Verhalten von combsol.app.
// =====================================================================

import { DEFAULT_INSTANCE, type InstanceConfig } from "../../../shared/instance";

declare global {
  interface Window {
    __HUB_INSTANCE__?: Partial<InstanceConfig>;
  }
}

function readInstance(): InstanceConfig {
  const injected = typeof window !== "undefined" ? window.__HUB_INSTANCE__ : undefined;
  if (!injected || typeof injected !== "object") return DEFAULT_INSTANCE;
  return { ...DEFAULT_INSTANCE, ...injected };
}

export const INSTANCE: InstanceConfig = readInstance();
